import { useAuthenticatedFetch } from '~/composables/useAuthenticatedFetch';
import useApiUrl from '~/composables/useApiUrl';

export default function useWatchTime (courseId: number | null | undefined, chapterId: number | null | undefined, contentId: number | null | undefined, submitAfterSeconds: number = 60) {
  let isPlaying = false;
  let watchTime = 0;
  let isSubmitting = false;

  const play = () => {
    isPlaying = true;
  };

  const pause = () => {
    isPlaying = false;
  };

  const destroy = () => {
    clearInterval(stopwatch);
  };

  const submit = async () => {
    if (!courseId || !chapterId || !contentId) {
      return;
    }

    if (watchTime < 5) {
      console.debug('Not submitting watch time because it less than 5 seconds.');
      return;
    }

    if (isSubmitting) {
      console.debug('Not submitting watch time because it is already submitting.');
      return;
    }

    const apiUrl = useApiUrl('courses/' + courseId + '/chapters/' + chapterId + '/contents/' + contentId + '/watchtime');
    isSubmitting = true;

    return useAuthenticatedFetch(apiUrl, {
      method: 'POST',
      body: {
        watchtime: watchTime,
      },
    })
      .then(() => watchTime = 0)
      .finally(() => {
        isSubmitting = false;
      });
  };

  const stopwatch = setInterval(async () => {
    if (!isPlaying) {
      return;
    }

    watchTime++;

    if (watchTime >= submitAfterSeconds) {
      await submit().catch(err => console.error(err));
    }
  }, 1000);

  return {
    play,
    pause,
    destroy,
    submit,
  };
}